<template lang="pug">
  el-dialog.select-brief-info-dialog(
    :title="$t('导出brief信息')"
    :visible="true"
    :show-close="false"
    v-loading="loading"
    :close-on-click-modal="false"
    @close="$emit('close')"
  )
    .select-brief-info__container
      .common_column
        .common_title {{ $t('项目') }}
        .common_items(:style="{ 'padding-left': !campaigns.length ? '0' : '30px' }")
          .empty_box(v-if="!campaigns.length" style="height:50px;text-align:center;line-height:50px;color:#e0e0e0") {{ $t('暂无项目') }}
          .common_item(
            v-for="item, index in campaigns"
            :class="{'activeItem': currentCampaignId === item.campaign_id}"
            @click="currentCampaignId = item.campaign_id"
          )
            span {{ item.campaign_name }}
            .icon
              img(
                src="@/umcc/assets/icon-miners.png"
                @click.stop="deleteCampaign(item, index)"
              )
          el-select(
            v-model="currentKeyword"
            filterable
            remote
            v-if="showSelection"
            :placeholder="$t('输入ID/项目名/BB Code查询')"
            :remote-method="handleSearch"
            :loading="selectionLoading"
            @change="handleSelect"
          )
            el-option(
              v-for="item in campaignOptions"
              :key="item.campaign_id"
              :label="item.campaign_name"
              :value="item.campaign_id"
              :disabled="campaigns.some(v => v.campaign_id === item.campaign_id)"
            )
          .addCampaign(v-else @click="showSelection = true" :style="{ 'margin-left': !campaigns.length ? '30px' : '0px' }")
            .icon
              img(
                src="@/umcc/assets/icon-add.png"
              )
            span {{ $t('添加项目') }}
      .common_column(v-loading="getsowLoding")
        .common_title {{ $t('子项目') }}
        .common_items(style="padding-left: 0")
          .empty_box(v-if="!sows.length" style="height 50px;text-align:center;line-height:50px;color:#e0e0e0") {{ $t('暂无子项目') }}
          .common_item(
            v-for="item, index in sows"
            @click="selectedSow(index)"
            :class="{'activeItem': selectedSows.some(v => v.sub_final_scope_id === item.sub_final_scope_id)}"
          )
            span {{ item.sub_final_scope_name }}
      .common_column
        .common_title {{ $t('已选择') }}
        .common_items(:style="{ 'padding-left': !selectedSows.length ? '0' : '30px' }")
          .empty_box(v-if="!selectedSows.length" style="height:50px;text-align:center;line-height:50px;color:#e0e0e0") {{ $t('暂无选择的子项目') }}
          .common_item(
            v-for="item, index in selectedSows"
          )
            span {{ item.sub_final_scope_name }}
            .icon
              img(
                src="@/umcc/assets/icon-miners.png"
                @click="selectedSows.splice(index, 1)"
              )
    div(style="text-align:right")
      footer-button(
        :confirmButton="$t('导出')"
        @confirm="exportBriefInfo"
        :confirmButtonDisabled="!selectedSows.length"
        @cancel="$emit('close')"
      )
</template>

<script>
import axios from 'axios'
import { cloneDeep } from 'lodash'
import FooterButton from '@/components/FooterButton'
export default {
  components: {
    FooterButton
  },
  data () {
    return {
      loading: false,
      selectionLoading: false,
      getsowLoding: false,
      campaignOptions: [],
      currentKeyword: '',
      showSelection: false,

      campaigns: [],
      currentCampaignId: null,
      sows: [],
      selectedSows: []
    }
  },
  methods: {
    exportBriefInfo () {
      this.loading = true
      axios.get('/management/ec/exportSow', {
        params: {
          sub_final_scope_id: this.selectedSows.map(item => item.sub_final_scope_id).join(',')
        }
      }).then(res => {
        this.loading = false
        window.open(res.download_url, '_blank')
        this.$message.success(this.$t('导出成功'))
        this.$emit('close')
      })
    },
    handleSelect (val) {
      this.campaigns.push(cloneDeep(this.campaignOptions.find(item => item.campaign_id === val)))
      this.campaignOptions = []
      this.currentKeyword = ''
      this.showSelection = false
    },
    handleSearch (val) {
      if (val) {
        this.selectionLoading = true
        axios.get('/management/ec/getCampaignListForExportSow', {
          params: {
            keyword: val
          }
        }).then(res => {
          this.campaignOptions = res
          this.selectionLoading = false
        })
      } else {
        this.campaignOptions = []
      }
    },
    deleteCampaign (item, index) {
      if (item.campaign_id === this.currentCampaignId) {
        this.currentCampaignId = null
      }
      this.campaigns.splice(index, 1)
    },
    selectedSow (index) {
      if (this.selectedSows.some(v => v.sub_final_scope_id === this.sows[index].sub_final_scope_id)) {
        return
      }
      this.selectedSows.push(cloneDeep(this.sows[index]))
    }
  },
  watch: {
    currentCampaignId () {
      if (this.currentCampaignId) {
        this.getsowLoding = true
        axios.get('/management/ec/getSowList', {
          params: {
            campaign_id: this.currentCampaignId
          }
        }).then(res => {
          this.sows = res
          this.getsowLoding = false
        })
      } else {
        this.sows = []
      }
    }
  }
}
</script>

<style lang="stylus">
.select-brief-info-dialog .el-dialog
  width 70%
  margin-top 8vh !important
.select-brief-info__container
  display flex
  justify-content space-between
  align-items center
  border-bottom 1px solid #e0e0e0
  margin-bottom 20px
  .common_column
    width 30%
    .common_title
      height 30px
      line-height 30px
      padding-left 20px
      background-color #fff
      border-bottom 1px solid #e0e0e0
    .common_items
      height calc(60vh - 32px)
      box-sizing border-box
      overflow scroll
      padding-left 30px
      padding-bottom 20px
      .el-select
        margin-top 15px
        width 100%
      .addCampaign
        margin-top 15px
        display flex
        font-size 18px
        align-items center
        height 30px
        color #4896e6
        line-height 30px
        width 120px
        cursor pointer
        position relative
        .icon
          position absolute
          top 0
          left -30px
          height 30px
          width 30px
          display flex
          justify-content center
          align-items center
          img
            width 20px
            height 20px
      .common_item
        cursor pointer
        position relative
        margin-top 10px
        border-radius 5px
        height 30px
        line-height 30px
        text-align center
        border 1px solid #e0e0e0
        .icon
          position absolute
          width 30px
          height 30px
          top 0
          left -30px
          display flex
          justify-content center
          align-items center
          img
            width 20px
            height 20px
      .activeItem
        border-color #4896e6
        background-color #4896e6
        color #fff
    .common_items::-webkit-scrollbar
      display none
</style>
